module.exports = {
    title: "公司介绍_杭州惠合信息_店商营销服务平台",
    description: "惠合科技成立于2016年，是全国领先的店商营销服务平台。公司一直以“传统渠道”为营销阵地，依托AI人工智能、大数据分析、一物一码等前沿技术，服务了可口可乐、农夫山泉、雀巢、玛氏箭牌等百余家国内外知名品牌。",
    keywords: "AI人工智能,大数据分析,一物一码,传统渠道营销,数字营销,惠合科技"
}